import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Tooltip,
} from "@mui/material";
import { FiGlobe } from "react-icons/fi";

const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
];

export const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const current = LANGUAGES.find((l) => l.code === i18n.language) ?? LANGUAGES[0];

  const handleSelect = (code: string) => {
    i18n.changeLanguage(code);
    setAnchor(null);
  };

  return (
    <>
      <Tooltip title={t("a11y.changeLanguage", "Change language")}>
        <IconButton
          aria-label={t("a11y.changeLanguage", "Change language")}
          size="small"
          onClick={(e) => setAnchor(e.currentTarget)}
          sx={{
            border: "1px solid",
            borderColor: "divider",
            borderRadius: "10px",
            px: 1,
            gap: 0.5,
            height: 36,
          }}
        >
          <FiGlobe size={15} />
          <Typography sx={{ fontSize: 12, fontWeight: 600 }}>
            {current.flag} {current.code.toUpperCase()}
          </Typography>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{ sx: { mt: 1, minWidth: 160, borderRadius: 2 } }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === i18n.language}
            onClick={() => handleSelect(lang.code)}
            sx={{ gap: 1.5, fontSize: 13 }}
          >
            <Box component="span" sx={{ fontSize: 18, lineHeight: 1 }}>
              {lang.flag}
            </Box>
            <Box>
              <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{lang.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
